module.exports = __webpack_public_path__ + "img/feibiaoN134-2-EN.721d404b.png";